import { render, staticRenderFns } from "./publicWeChatManage.vue?vue&type=template&id=24b48955&scoped=true"
import script from "./publicWeChatManage.vue?vue&type=script&lang=js"
export * from "./publicWeChatManage.vue?vue&type=script&lang=js"
import style0 from "./publicWeChatManage.vue?vue&type=style&index=0&id=24b48955&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b48955",
  null
  
)

export default component.exports